import { ASSET_FILES, SLIDES } from "./slides";
import { publicAsset, publicThumb } from "./publicAsset";

function loadImageUrl(url) {
  return new Promise((resolve) => {
    const img = new Image();
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      if (typeof img.decode === "function") {
        img.decode().catch(() => {}).finally(() => resolve());
      } else {
        resolve();
      }
    };
    img.addEventListener("load", finish, { once: true });
    img.addEventListener(
      "error",
      () => {
        if (settled) return;
        settled = true;
        resolve();
      },
      { once: true }
    );
    img.src = url;
    if (img.complete && img.naturalWidth > 0) {
      queueMicrotask(finish);
    }
  });
}

function collectGalleryUrls(mapper) {
  const urls = new Set();
  for (const slide of SLIDES) {
    if (!slide.images?.length) continue;
    for (const key of slide.images) {
      const file = ASSET_FILES[key];
      if (typeof file === "string") urls.add(mapper(file));
    }
  }
  return [...urls];
}

let preloadThumbsPromise;
let preloadFullsPromise;

/** Warm small previews first (initial loader should await this). */
export function preloadGalleryThumbs() {
  if (!preloadThumbsPromise) {
    const list = collectGalleryUrls(publicThumb);
    preloadThumbsPromise = Promise.all(list.map((url) => loadImageUrl(url))).then(() => {});
  }
  return preloadThumbsPromise;
}

/** Warm full-size gallery URLs in the background after thumbs. */
export function preloadGalleryFulls() {
  if (!preloadFullsPromise) {
    const list = collectGalleryUrls(publicAsset);
    preloadFullsPromise = Promise.all(list.map((url) => loadImageUrl(url))).then(() => {});
  }
  return preloadFullsPromise;
}
